import { productionTariffConstants as C } from '../actions/constants'

const initialState = {
    tariffs: [],
    resolved: {},
    calculations: {},
    loading: false,
    resolving: false,
    calculating: false,
    error: null,
}

const makeResolveKey = ({ productId, categoryId, operationType }) =>
    [productId || 'none', categoryId || 'none', operationType || 'none'].join(':')

const productionTariffReducer = (state = initialState, action) => {
    switch (action.type) {
        case C.LIST_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            }

        case C.RESOLVE_REQUEST:
            return {
                ...state,
                resolving: true,
                error: null,
            }

        case C.CALCULATE_REQUEST:
            return {
                ...state,
                calculating: true,
                error: null,
            }

        case C.LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                tariffs: action.payload || [],
            }

        case C.RESOLVE_SUCCESS: {
            const key = makeResolveKey(action.payload)

            return {
                ...state,
                resolving: false,
                resolved: {
                    ...state.resolved,
                    [key]: {
                        tariff: action.payload.tariff,
                        tariffs: action.payload.tariffs || [],
                    },
                },
            }
        }

        case C.CALCULATE_SUCCESS:
            return {
                ...state,
                calculating: false,
                calculations: {
                    ...state.calculations,
                    [action.payload.tariffId]: action.payload.calculation,
                },
            }

        case C.LIST_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            }

        case C.RESOLVE_FAILURE:
            return {
                ...state,
                resolving: false,
                error: action.payload,
            }

        case C.CALCULATE_FAILURE:
            return {
                ...state,
                calculating: false,
                error: action.payload,
            }

        default:
            return state
    }
}

export default productionTariffReducer